import { getters } from "SelectiveApproversLabel";

const mergeIds = ids => ids.join("_");

export const getLoadingApproval = (state, { recordIds }) =>
  Boolean(getters.loadingApproval(state)[mergeIds(recordIds)]);

export const getResponse = (state, { recordIds }) =>
  getters.responses(state)[mergeIds(recordIds)];
